import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface SpinnerProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  variant?: "default" | "muted";
  className?: string;
}

const sizeClasses = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

export function Spinner({ size = "md", variant = "default", className }: SpinnerProps) {
  return (
    <Loader2
      aria-hidden="true"
      className={cn(
        "animate-spin",
        sizeClasses[size],
        variant === "default" ? "text-primary" : "text-muted-foreground",
        className
      )}
    />
  );
}
